var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QS-h4-title',{attrs:{"title":"应付业务信息"}}),_vm._v(" "),_c('el-form',{attrs:{"label-width":"140px"}},[_c('column-box',{attrs:{"source":_vm.source,"list":_vm.list,"column":3,"label-width":130}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }